<div class="avatar" [class.small]="size === 'small'" #popupActivator>
    <div *ngIf="!_additionalContacts; else displayShowMore" class="avatar__initials">
        {{ _contact | getInitials }}
    </div>
    <ng-template #displayShowMore>
        <div class="avatar__initials">+{{ _additionalContacts.length }}</div>
    </ng-template>
</div>
<div class="ui popup">
    <p class="popup__text">{{ popupText }}</p>
    <div class="popup__avatar-inception">
        <div *ngIf="_additionalContacts; else displaySingleContact" class="popup__additional-contacts">
            <div *ngFor="let additionalContact of _additionalContacts" class="additional-contacts__wrapper">
                <div class="avatar small">
                    <div class="avatar__initials">{{ additionalContact | getInitials }}</div>
                </div>
                <span class="avatar__name">{{ additionalContact.name || additionalContact.email }}</span>
            </div>
        </div>
        <ng-template #displaySingleContact>
            <div class="avatar small">
                <div class="avatar__initials">{{ _contact | getInitials }}</div>
            </div>
            <span class="avatar__name">{{ _contact.name || _contact.email }}</span>
        </ng-template>
    </div>
</div>
